<template>
  <div class="responsive-container">
    <div class="small-screen-side-content hidden">
      <slot name="side-content"></slot>
    </div>
    <div class="flex-stretch">
      <slot name="content"></slot>
    </div>
    <div class="side-bar">
      <slot name="buttons"></slot>
      <div class="large-screen-side-content">
        <slot name="side-content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerPageResponsiveLayout",
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.responsive-container{
  display: flex;
  flex-direction: row;
  gap: $spacing-lg;
}
.side-bar{
  width: 350px;
}

@media (max-width: $screen-lg-min) {
  .responsive-container {
    flex-direction: column-reverse;
  }

  .small-screen-side-content{
    display: block !important;
  }

  .side-bar{
    width: 100%;

    .large-screen-side-content {
      display: none;
    }

    .list-group{
      flex-wrap: wrap;
      display: flex;
      column-gap: $spacing-sm;
      row-gap: $spacing-xs;
      margin-bottom: 0 !important;

      .list-group-item{
        width: calc(50% - #{$spacing-md}) !important;
        border-radius: 50px;
        color: $list-group-link-hover-color;
        background-color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
